import { render, staticRenderFns } from "./wechatList.vue?vue&type=template&id=b5d5d442&scoped=true"
import script from "./wechatList.vue?vue&type=script&lang=js"
export * from "./wechatList.vue?vue&type=script&lang=js"
import style0 from "./wechatList.vue?vue&type=style&index=0&id=b5d5d442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d5d442",
  null
  
)

export default component.exports